"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("../constants");

// 捕获浏览器信息
var _default = function _default() {
  return {
    data: {
      ua: window.navigator.userAgent
    },
    name: _constants.METRIC_BROWSER_INFO,
    type: _constants.METRIC_COUNTER_TYPE
  };
};

exports.default = _default;